import { UtilitiesError } from '../api/utilitiesAPI';

export function formatMoney(value) {
  if (value === null || value === undefined || value === '') return '';
  const n = Number(value);
  if (!Number.isFinite(n)) return String(value);
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

/** "2026-11-04" shows as "Nov 4", or "Nov 4, 2025" outside the current year, as Odoo does. */
export function formatDate(iso) {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso || '');
  if (!match) return '';
  const label = `${MONTHS[Number(match[2]) - 1]} ${Number(match[3])}`;
  return Number(match[1]) === new Date().getFullYear() ? label : `${label}, ${match[1]}`;
}

/** Many2one fields come back as {id, name}; form values need the plain id. */
export function many2oneId(value) {
  if (value && typeof value === 'object') return value.id ?? null;
  return value ?? null;
}

/** Display text for a many2one or plain value. */
export function many2oneName(value) {
  if (value && typeof value === 'object') return value.name || '';
  return value ?? '';
}

export function optionLabel(option) {
  return option?.name || option?.label || option?.code || String(option?.id ?? '');
}

/** The server returns 401 when the token has expired or is missing. */
export function isUnauthorized(error) {
  return error instanceof UtilitiesError && Number(error.statusCode) === 401;
}

/** Records can come back under a few keys; take the first array we find. */
export function pickRecords(response, resourceKey) {
  const candidates = [response?.records, response?.items, response?.data, response?.[resourceKey]];
  return candidates.find((c) => Array.isArray(c)) || [];
}

export function pickTotal(response, fallback = 0) {
  const total = response?.total ?? response?.count ?? response?.total_count;
  return Number.isFinite(Number(total)) ? Number(total) : fallback;
}

export function stateBadgeClass(state) {
  if (state === 'posted') return 'bg-green-100 text-green-800';
  if (state === 'cancel' || state === 'cancelled') return 'bg-red-100 text-red-800';
  return 'bg-amber-100 text-amber-800';
}
